<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const modal = computed(() => store.getters["toastNotification/modal"]);
const showModal = computed(() => store.getters["toastNotification/showModal"]);
const title = computed(() => modal.value.title);
const message = computed(() => modal.value.message);
const icon = computed(() => modal.value.icon);
const type = computed(() => modal.value.type);

const modalTypeClass = computed(() => {
  if (type.value) {
    return `modal-${type.value}`;
  }
  return "";
});

const closeModal = () => {
  store.commit("toastNotification/HIDE_MODAL");
};
</script>
<template>
  <div v-if="showModal">
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
      <div class="modal-backdrop fade show" @click="closeModal"></div>
      <div class="modal-dialog">
        <div :class="['modal-content', modalTypeClass]">
          <div class="modal-header">
            <h4 class="modal-title">
              <i v-if="icon" :class="[icon, 'me-2']"></i>
              {{ title }}
            </h4>
            <button type="button" class="close" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div style="white-space: pre-line" class="text">
              {{ message }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "@/styles/modal.css";
.modal-content {
  background-color: #343a40;
}

.modal-info {
  border-left: 4px solid #2196f3;
}

.modal-info .modal-body {
  color: #2196f3;
}

.modal-info .modal-header {
  background: #2196f3;
  color: #fff;
  border-bottom: none;
}

.modal-info .modal-header .modal-title {
  color: #fff;
}

.modal-info .modal-header .btn-close {
  filter: brightness(0) invert(1);
}

.modal-success {
  border-left: 4px solid #00bc8c;
}

.modal-success .modal-body {
  color: #00bc8c;
}

.modal-success .modal-header {
  background: #00bc8c;
  color: #fff;
  border-bottom: none;
}

.modal-success .modal-header .modal-title {
  color: #fff;
}

.modal-success .modal-header .btn-close {
  filter: brightness(0) invert(1);
}

.modal-warning {
  border-left: 4px solid #ffc107;
}

.modal-warning .modal-body {
  color: #ffc107;
}

.modal-warning .modal-header {
  background: #ffc107;
  color: #000000;
  border-bottom: none;
}

.modal-warning .modal-header .modal-title {
  color: #000000;
}

.modal-error {
  border-left: 4px solid #e12e1c;
}

.modal-error .modal-body {
  color: #e12e1c;
}

.modal-error .modal-header {
  background: #e12e1c;
  color: #fff;
  border-bottom: none;
}

.modal-error .modal-header .modal-title {
  color: #fff;
}

.modal-error .modal-header .btn-close {
  filter: brightness(0) invert(1);
}
</style>
